// action
import {
  ajaxIPInfo
} from './getData';

const NO_CONTENT = "NO_CONTENT";
import moment from 'moment'
import { getCookie } from "@/utils/utils";

import {
  GET_COUNTRY_INFO
} from './mutation-types';
import router from '../router';

export default {
    //  获取IP信息
    async getIPInfo({ commit }) {
      const res = await ajaxIPInfo();
      // const res = {"country":"本机地址","message":"get user info successfully"};
      try {
        // .io自动跳转.work
        let country = res.country;
        let host = window.location.host;
        if (country == '中国' && (host == 'console.bonuscloud.io' || host.includes('8080'))) {
          window.location.href = 'https://bonuscloud.work';
        }
  
        commit(GET_COUNTRY_INFO, res.country);
      } catch (error) {
        commit(GET_COUNTRY_INFO, '');
      }
      return res;
    },
};

